export const cols = [{
	prop: 'orderType',
	label: '单据类型',
	width: '120',
	align: 'center'
}, {
	prop: 'orderNo',
	label: '单据编号',
	width: '200',
	align: 'center'
}, {
	prop: 'createDate',
	label: '下单时间',
	width: '160',
	align: 'center'
}, {
	prop: 'entName',
	label: '供货商名称',
	width: '180',
	align: 'center'
}, {
	prop: 'shopName',
	label: '供货商店铺名称',
	width: '180',
	align: 'center'
}, {
	prop: 'buyer',
	label: '采购门店名称',
	width: '180',
	align: 'center'
}, {
	prop: 'bigCate',
	label: '商品大类',
	width: '180',
	align: 'center'
}, {
	prop: 'samllCate',
	label: '商品小类',
	width: '180',
	align: 'center'
}, {
	prop: 'pname',
	label: '商品名称',
	width: '120',
	align: 'center'
}, {
	prop: 'specs',
	label: '规格',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'punit',
	label: '单位',
	width: '120',
	align: 'center'
}, {
	prop: 'itemquantity',
	label: '订货数量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendCount',
	label: '实发数量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendDiffCount',
	label: '实发差异数量',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'getCount',
	label: '实收数量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'getDiffCount',
	label: '实收差异数量',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'price',
	label: '单价',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'itemmoney',
	label: '订货金额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendPrice',
	label: '实发金额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendDiffPrice',
	label: '实发差异金额',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'getPrice',
	label: '实收金额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'getDiffPrice',
	label: '实收差异金额',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'refundCount',
	label: '退单数量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'refundPrice',
	label: '退单金额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'getter',
	label: '收货人',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'tel',
	label: '联系电话',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'address',
	label: '收货地址',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'companycode',
	label: '物流公司',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'ffnumber',
	label: '物流单号',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}]
